import type { Plugin } from '@web-platform/shared-universal-types/src/network/acorn/endpoints';
import type { CreativesPlugin } from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';

export const extractCreativesPlugin = (plugins: Plugin[] = []): CreativesPlugin | undefined =>
  plugins.find(
    (plugin): plugin is CreativesPlugin =>
      plugin['@type'] === 'type.googleapis.com/deliveryservice.Creatives',
  );
